import React from 'react'
import { Button } from '@/shared/ui'
import { Link } from 'react-router-dom'
import { useAuth } from '@/modules/auth/context/AuthContext'

export default function AccessDeniedPage() {
  const { user, profile } = useAuth()
  const MASTER_EMAIL = (import.meta.env.VITE_MASTER_EMAIL as string) || 'rgo.mendes@gmail.com'
  const isMasterEmail = (user?.email || '').toLowerCase() === MASTER_EMAIL.toLowerCase()
  const dashboardDest = isMasterEmail || profile?.role === 'master' ? '/dashboard-master' : '/profile'

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-6 py-16">
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center text-center">
        <div className="mb-8 w-full max-w-md">
          <AccessDeniedIllustration />
        </div>
        <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">Acesso não permitido</h1>
        <p className="mt-3 max-w-prose text-foreground/80">
          Você não tem permissão para acessar esta página. Se acredita que isso é um engano, entre em contato com o administrador.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          {user ? (
            <Button asChild>
              <Link to={dashboardDest}>Retornar ao painel</Link>
            </Button>
          ) : (
            <Button asChild>
              <Link to="/">Retornar à Home</Link>
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

function AccessDeniedIllustration() {
  return (
    <svg viewBox="0 0 400 260" className="h-auto w-full" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="g1" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity="0.35" />
          <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity="0.05" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="400" height="260" rx="16" fill="url(#g1)" opacity="0.18" />
      <g transform="translate(200,130)">
        <rect x="-70" y="-10" width="140" height="110" rx="14" fill="currentColor" opacity="0.07" />
        <rect x="-70" y="-10" width="140" height="110" rx="14" stroke="hsl(var(--border))" fill="none" />
        <path d="M -35 -10 v -25 a 35 35 0 0 1 70 0 v 25" stroke="hsl(var(--foreground))" strokeOpacity="0.7" strokeWidth="8" fill="none" />
        <circle cx="0" cy="35" r="10" fill="hsl(var(--primary))" />
        <rect x="-6" y="45" width="12" height="22" rx="3" fill="hsl(var(--primary))" />
      </g>
    </svg>
  )
}